(ns manage.adset-decision-tree-page.view.side-panel.feed.selector
  (:require ["@mui/material/Autocomplete$default" :as Autocomplete]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/Link$default" :as Link]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/SvgIcon$default" :as SvgIcon]
            ["@mui/material/TextField$default" :as TextField]
            ["@mui/material/Typography$default" :as Typography]
            ["@mui/x-data-grid-premium" :refer [DataGridPremium]]
            ["react-hook-form" :as rhf]
            ["src/svg/files_folders/file-spreadsheet.svg$default"
             :as FileSpreadsheet]
            ["src/svg/inform/plus.svg$default" :as PlusIcon]
            ["src/svg/wpp/content-actions/external-link.svg$default"
             :as ExternalLink]
            [cljs-bean.core :refer [->clj ->js]]
            [common.modal.view :refer [defmodal modal-v2]]
            [common.queries :refer [use-infinite-query use-query]]
            [common.resource.query.feed
             :refer [dynamic-feed-query platform-dynamic-feeds-query]]
            [common.resource.query.feed-importer :refer [feed-importers-query]]
            [common.util :as util :refer [format-iso-string spread-props]]
            [common.widgets.data-grid :as dg]
            [manage.adset-decision-tree-page.view.side-panel.util
             :refer [grey-container-sx]]
            [manage.adset-decision-tree-page.view.table-util :as tu]
            [re-frame.core :as rf]
            [reitit.frontend.easy :as rfe]
            [uix.core :as uix :refer [$ defhook defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defn get-columns []
  #js [#js {:field "name"
            :headerName "Feed name"
            :valueGetter (fn [_value row] (:name row))
            :flex 5}
       #js {:field "time"
            :headerName "Last modified"
            :valueGetter (fn [_value {:keys [updated-at]}]
                           (util/format-iso-string updated-at))
            :flex 2}])

(def get-row-count (comp :total :meta))

(defui select-feed-table [{:keys [selection set-selection]}]
  (let [columns (uix/use-memo (fn [] (get-columns))
                              [])

        {:keys [advertiser-id]} (use-subscribe [:url-context])
        table-query-fn (uix/use-callback
                        (fn [_table-models]
                          (platform-dynamic-feeds-query
                           {:advertiser-id advertiser-id}))
                        [advertiser-id])
        server-table-props (dg/use-server-table-props
                            {:table-query-fn table-query-fn
                             :disable-default-transform true
                             :transform-response-fn :items
                             :get-row-count-fn get-row-count
                             :initial-pagination-model #js {:page 0 :pageSize 10}})]
    ($ DataGridPremium (merge
                        server-table-props
                        {:columns columns
                         :autosizeOnMount true
                         :getRowId (fn [row] (:id row))
                         :checkboxSelection true
                         :onRowSelectionModelChange set-selection
                         :rowSelectionModel selection
                         :disableColumnMenu true
                         :disableRowSelectionOnClick true
                         :disableMultipleRowSelection true
                         :sx (clj->js tu/modal-table-default-sx)}))))

(defmodal feed-selection-modal ::modal-id
  [{:keys [value on-change]}]
  (let [[selection set-selection] (uix/use-state (cond-> []
                                                   (some? value) (conj value)
                                                   true to-array))]
    ($ modal-v2 {:title "Select feed"
                 :footer ($ Stack {:direction "row"
                                   :spacing 1}
                            ($ Button {:onClick (fn [_] (rf/dispatch [:modal/close]))}
                               "Cancel")
                            ($ Button {:variant "contained"
                                       :on-click (fn []
                                                   (on-change (first selection))
                                                   (rf/dispatch [:modal/close]))
                                       :disabled (empty? selection)}
                               "Select"))

                 :dialog-content-props {:sx #js {:display "flex"
                                                 :flexDirection "column"
                                                 :overflow "hidden"}}}
       ($ select-feed-table {:selection selection
                             :set-selection set-selection}))))

(defhook use-assigned-feed-name [feed-id]
  (let [{:keys [advertiser-id]} (use-subscribe [:url-context])
        {{assigned-feed-name :name} :data}
        (use-query (dynamic-feed-query {:feed-importer-id feed-id
                                        :advertiser-id advertiser-id}))]
    assigned-feed-name))

(defui use-feed-href-props []
  (let [link-context (use-subscribe [:router/path-params])]
    {:href (rfe/href :advertiser/feeds link-context)
     :target "_blank"}))

(defui selected-feed [{:keys [feed-id]}]
  (let [assigned-feed-name (use-assigned-feed-name feed-id)
        feed-href-props (use-feed-href-props)]
    ($ Stack {:direction "row"
              :spacing 1
              :sx grey-container-sx}
       ($ SvgIcon ($ FileSpreadsheet))
       ($ Link feed-href-props
          (or assigned-feed-name " ")))))

(defui feed-selection-modal-buttons
  [{{:keys [onChange value]} :field}]
  ($ Stack {:direction "row"
            :justifyContent "flex-end"
            :spacing 1}
     ;; TODO
     #_($ Button
          {:variant "contained"
           :color "grey"
           :startIcon ($ UploadIcon)
           :onClick
           (fn [^js _event]
             (rf/dispatch [:modal/open {:id :ad-variant/import-feed}]))}
          "Upload")
     ($ Button
        {:variant "contained"
         :color "grey"
         :startIcon ($ PlusIcon)
         :onClick (fn [^js _event]
                    (rf/dispatch [:modal/open {:id ::modal-id
                                               :props {:on-change onChange
                                                       :value value}}]))}
        "Select")))

(defui modal-feed-select [{{feed-id :value} :field :as props}]
  (if (some? feed-id)
    ($ selected-feed {:feed-id feed-id})
    ($ feed-selection-modal-buttons props)))

(defui feed-option [{:keys [li-props ^js option]}]
  ($ :li (js/Object.assign li-props #js {:style #js {:height "auto"}})
     ($ Stack {:direction "row"
               :alignItems "center"
               :gap 1
               :sx #js {:flex 1
                        :overflow "hidden"}}

        ($ Stack {:direction "column"
                  :sx #js {:flex 1
                           :overflow "hidden"}}
           ($ Typography {:component "span"}
              (.-label option))
           ($ Typography {:component "span"
                          :color "text.secondary"}
              (format-iso-string (.-updated option))))
        ($ IconButton (use-feed-href-props)
           ($ ExternalLink)))))

(defn render-feed-option [props option]
  ($ feed-option {:key (.-value option) :li-props props :option option}))

(defui feed-selector-autocomplete [{{:keys [error]} :fieldState
                                    {:keys [onChange value]} :field}]
  (let [{:keys [advertiser-id]} (use-subscribe [:url-context])
        [input-value set-input-value] (uix/use-state "")
        selected-value (uix/use-ref nil)
        assigned-feed-name (use-assigned-feed-name value)
        {feed-importers :data isLoading :isLoading}
        (use-infinite-query (feed-importers-query
                             {:advertiser-id advertiser-id
                              :filters [{:field "type" :value "lookup"}
                                        {:field "name" :value input-value}]
                              :sort {:field "updated-at" :sort "desc"}
                              :page-size 10}))

        feed-importer-options
        (uix/use-memo #(->> (get-in feed-importers [:pages 0 :items])
                            (map (fn [feed] {:label (:name feed)
                                             :value (:id feed)
                                             :updated (:updated-at feed)}))
                            ->js)
                      [feed-importers])]
    ($ Autocomplete
       {:size "small"
        :value value
        :onChange (fn [_ value]
                    (onChange (when (some? value)
                                (reset! selected-value value)
                                (.-value value))))
        :options feed-importer-options
        :isOptionEqualToValue (fn [option value] (= (.-value option) value))
        :getOptionKey (fn [option] (.-value option))
        :getOptionLabel (fn [option]
                          (or
                           ;; Rendering label in list
                           (.-label option)
                           ;; Rendering selected label
                           (when (and @selected-value (= option (.-value @selected-value)))
                             (.-label @selected-value))
                           ;; Rendering selected label initially
                           assigned-feed-name
                           ""))
        :renderOption render-feed-option
        :noOptionsText (if isLoading
                         "Loading feeds…"
                         "No feed found")
        :filterOptions identity
        :onInputChange (fn [_ ^js new-input-value]
                         (set-input-value new-input-value))
        :renderInput (fn [^js props]
                       ($ TextField (spread-props props
                                                  #js {:helperText (:message error)
                                                       :error (boolean error)
                                                       :placeholder "Select feed"})))
        :fullWidth true})))

(defn adjust-on-change [{:keys [resetField clearErrors]} field-names onChange]
  (fn [new-value]
    (onChange new-value)
    (clearErrors)
    (doseq [field-name field-names]
      (resetField field-name #js {:defaultValue nil}))))

(defui feed-selector
  [{{:keys [control]} :form-control
    :keys [field-name view-type reset-fields form-control]}]
  (let [selector-component (case view-type
                             :modal modal-feed-select
                             :autocomplete feed-selector-autocomplete)]
    ($ rhf/Controller
       {:name field-name
        :control control
        :render (fn [^js props]
                  ($ selector-component
                     (update-in (->clj props) [:field :onChange]
                                (partial adjust-on-change form-control reset-fields))))})))
